import React, { useState, useEffect, useContext } from 'react';
import { Container, IconButton, Box, Button } from '@mui/material';
import DataTable from '../components/DataTable';
import PageTitle from '../components/PageTitle';
import { useConfirm } from '../assets/contexts/confirmContext';
import { useNotification } from '../assets/contexts/notificationContext';
import Loader from '../components/loader';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import * as endPoints from '../assets/js/endpoints';
import { useNavigate } from 'react-router-dom';
import { ACTION_ICON_COLORS } from '../constants/iconActionColors';
import { UserContext } from '../assets/contexts/userContext';
import AddIcon from '@mui/icons-material/Add';
import { Helmet } from 'react-helmet';

const EmployeeReports = () => {
  const { user } = useContext(UserContext);
  const [reports, setReports] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();
  const confirm = useConfirm();
  const { showNotification } = useNotification();

  const fetchReports = async () => {
    if (!user.id) return;
    try {
      setLoading(true);
      const data = await endPoints.getReports();
      const list = Array.isArray(data) ? data : data.data;
      setReports(list);
      if (list.length === 0) {
        showNotification('Aún no tienes informes', 'info');
      }
    } catch (error) {
      showNotification('Error al obtener informes', 'error');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchReports();
  }, [user.id]);

  const handleDelete = async id => {
    const ok = await confirm('¿Eliminar informe?');
    if (!ok) return;
    try {
      setLoading(true);
      await endPoints.deleteReport(id);
      await fetchReports();
      showNotification('Informe eliminado', 'success');
    } catch (error) {
      showNotification('Error eliminando informe', 'error');
    } finally {
      setLoading(false);
    }
  };

  const handleEdit = id => navigate(`/employee/createReport/${id}`);
  const handleCreate = () => navigate('/employee/createReport');

  if (loading) return <Loader />;

  const columns = [
    { id: 'title', label: 'Título' },
    { id: 'clientName', label: 'Cliente' },
    { id: 'serviceName', label: 'Servicio' },
    { id: 'date', label: 'Fecha' },
  ];

  const rows = reports.map(r => ({
    ...r,
    clientName: r.client?.name,
    serviceName: r.service?.name,
    date: r.session_date
    ? new Date(r.session_date).toLocaleDateString('es-ES', {
        year: 'numeric', month: '2-digit', day: '2-digit'
      })
    : '',
  }));

  const actions = report => (
    <>
      <IconButton onClick={() => handleEdit(report.id)} sx={{ color: ACTION_ICON_COLORS.edit }}>
        <EditIcon />
      </IconButton>
      <IconButton onClick={() => handleDelete(report.id)} sx={{ color: ACTION_ICON_COLORS.delete }}>
        <DeleteIcon />
      </IconButton>
    </>
  );

  return (
    <>
      <Helmet>
        <title>Mis Informes | CES</title>
      </Helmet>
      <Container sx={{ mt:3 }}>
        <Box sx={{ display:'flex', justifyContent:'space-between', alignItems:'center', mb:2 }}>
          <PageTitle>Mis Informes</PageTitle>
          <Button variant="contained" startIcon={<AddIcon />} onClick={handleCreate}>Crear Nuevo Informe</Button>
        </Box>
        <DataTable columns={columns} rows={rows} actions={actions} />
      </Container>
    </>
  );
};

export default EmployeeReports;
